export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Български (Bulgarian)' },
  { code: 'de', label: 'Deutsch (German)' },
  { code: 'fr', label: 'Français (French)' },
  { code: 'ro', label: 'Română (Romanian)' },
  { code: 'tr', label: 'Türkçe (Turkish)' },
  { code: 'sr', label: 'Српски (Serbian)' },
  { code: 'mk', label: 'Македонски (Macedonian)' },
  { code: 'hu', label: 'Magyar (Hungarian)' },
  { code: 'sk', label: 'Slovenčina (Slovakian)' },
  { code: 'sl', label: 'Slovenščina (Slovenian)' },
  { code: 'es', label: 'Español (Spanish)' },
  { code: 'fi', label: 'Suomi (Finnish)' },
  { code: 'el', label: 'Ελληνικά (Greek)' },
];
